import { produce } from "immer";
import storage from "@storage";
import * as uiActions from "./uiActions";

const VIEWS = ["list", "grid"];
const storedView = storage.get("documents_view");

const initialState = {
  isLoading: true,
  errorMessage: null,
  deleteDocumentIds: null,
  deleteDocumentName: null,
  updateDocumentIds: null,
  updateDocumentName: null,
  updateDocumentError: null,
  view: VIEWS.includes(storedView) ? storedView : "list",
  selected: {
    byId: {},
    allIds: []
  },
  shareToCompose: {
    status: false,
    ids: [],
    urls: {}
  }
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case uiActions.FETCH_DOCUMENTS_PENDING: {
      draft.isLoading = true;
      draft.errorMessage = null;
      break;
    }

    case uiActions.FETCH_DOCUMENTS_SUCCESS: {
      draft.isLoading = false;
      break;
    }

    case uiActions.FETCH_DOCUMENTS_FAILED: {
      draft.isLoading = false;
      draft.errorMessage = action.payload;
      break;
    }

    case uiActions.RESET_DOCUMENTS: {
      draft.isLoading = true;
      draft.errorMessage = null;
      break;
    }

    case uiActions.SET_ERROR_MESSAGE: {
      draft.errorMessage = action.payload;
      break;
    }

    case uiActions.UPDATE_DOCUMENT_PENDING: {
      draft.isLoading = true;
      draft.updateDocumentError = null;
      break;
    }

    case uiActions.UPDATE_DOCUMENT_SUCCESS: {
      draft.isLoading = false;
      draft.updateDocumentError = null;
      draft.updateDocumentIds = null;
      draft.updateDocumentName = null;
      break;
    }

    case uiActions.UPDATE_DOCUMENT_FAILED: {
      draft.updateDocumentError = action.payload.updateDocumentError;
      draft.isLoading = false;
      break;
    }

    case uiActions.SET_DOCUMENT_UPDATE_MODAL: {
      const { payload } = action;
      draft.updateDocumentIds = payload.updateDocumentIds;
      draft.updateDocumentName = payload.updateDocumentName;
      break;
    }

    case uiActions.CLOSE_DOCUMENT_UPDATE_MODAL: {
      draft.updateDocumentIds = null;
      draft.updateDocumentName = null;
      break;
    }

    case uiActions.DELETE_DOCUMENT: {
      draft.isDeleteLoading = true;
      break;
    }

    case uiActions.SET_DELETE_DOCUMENT_MODAL: {
      const { payload } = action;
      draft.deleteDocumentIds = payload.deleteDocumentIds;
      draft.deleteDocumentName = payload.deleteDocumentName;
      break;
    }

    case uiActions.DELETE_DOCUMENT_SUCCESS: {
      draft.isDeleteLoading = false;
      draft.deleteDocumentIds = null;
      draft.deleteDocumentName = null;
      break;
    }

    case uiActions.DELETE_DOCUMENT_FAILED: {
      draft.isDeleteLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;
    }

    case uiActions.CLOSE_DOCUMENT_DELETE_MODAL: {
      draft.deleteDocumentIds = null;
      draft.deleteDocumentName = null;
      break;
    }

    case uiActions.SELECT_SINGLE: {
      const payload = action.payload;
      if (payload.isSelected) {
        draft.selected.byId[payload.id] = true;
        draft.selected.allIds.push(payload.id);
      } else {
        draft.selected.byId[payload.id] = false;
        draft.selected.allIds = draft.selected.allIds.filter(
          id => id !== payload.id
        );
      }
      break;
    }

    case uiActions.SELECT_ALL: {
      const payload = action.payload;
      const byId = action.payload.list.reduce((obj, id) => {
        obj[id] = true;
        return obj;
      }, {});
      if (payload.isSelected) {
        draft.selected.byId = byId;
        draft.selected.allIds = [...action.payload.list];
      } else {
        draft.selected.byId = {};
        draft.selected.allIds = [];
      }
      break;
    }

    case uiActions.SHARE_TO_COMPOSE: {
      const { id, url } = action.payload;
      draft.shareToCompose.status = true;
      draft.shareToCompose.ids.push(id);
      if (url) {
        draft.shareToCompose.urls[id] = url;
      }
      break;
    }

    case uiActions.CLEAR_SHARE_TO_COMPOSE: {
      draft.shareToCompose.status = false;
      draft.shareToCompose.ids = [];
      draft.shareToCompose.urls = {};
      break;
    }

    case uiActions.CHANGE_VIEW: {
      const payload = action.payload;
      draft.view = payload;
      break;
    }
    default:
      return draft;
  }
}, initialState);

export default reducer;
